<template>
  <section 
  id="as-section-education"
  class="as-section as-section--has-padding as-section--education-center"
  data-section="education">
    <div class="container container--narrow">

      <div class="as-section__intro" :class="hasPosts ? '' : 'mb-0'">
        <h2 class="as-section__title">Explore Content by Our <br class="d-none d-xl-block" />Real Estate Investment Experts</h2>
        <a href="/education" class="btn btn--cta btn--cta--primary btn--cta--pill text-nowrap" target="_blank">
          <i class="fal fa-graduation-cap"></i>
          <span class="the-text">Visit Education Center</span>
        </a>  
      </div>

      <div class="post-rows">

        <a class="post-row" v-for="(post, key) in posts" :href="`/education/${post.slug}`" :key="key" target="_blank">
          <div class="post-row__featured-img" :style="{ backgroundImage: 'url(' + post.featuredimage + ')' }"></div>
          <div class="post-row__content">
            <span class="post-row__date"><i class="fal fa-clock text-info mr-1"></i>{{post.created | formatDate("YYYY-MM-DD") }}</span>
            <h3 class="post-row__title">
              {{post.title}}
            </h3>
            <div class="post-row__body">
              <p>{{post.summary}}</p>
            </div>
            <span  class="post-row__link">
              <span class="the-text">View Post</span>
              <i class="fal fa-chevron-right text-success"></i>
            </span>
          </div>
        </a>

      </div>

      <template v-if="initialized && !loading && !hasPosts">
        <div class="as-section__empty-state mt-6">
          <div class="as-section__empty-state__icon">
            <i class="fad fa-graduation-cap"></i>
          </div>
          <h3 class="as-section__empty-state__heading"><strong>Our {{officeName}} office has not published any articles yet.</strong></h3>
          
          <p class="as-section__empty-state__sub-heading">
            We are hard at work on new content. In the mean time, please visit the Renters Warehouse Education Center to view broader content on property management or real estate investing in general.
          </p>
          
        </div>
      </template>
      
    </div>
  </section>
</template>
<script>
import WaypointMixin from '@vue/mixins/waypoint-mixin';
export default {
  mixins: [
    WaypointMixin
  ],

  props: {
    posts: {
      type: Array,
      required: true
    },
    locationText: {
      type: String
    },
    officeName: {
      type: String
    },
    initialized: { type: Boolean },
    loading: { type: Boolean },
  },
  
  mounted() {
    this.$emit('cmp-mounted');
    this.$addObserver(this.$el, this.onWaypointEnter, this.intersectionOptions);
  },

  computed: {
    hasPosts(){
      return this.posts && this.posts.length > 0;
    },
  }
}
</script>